<div class="pb-4 ps-2 ps-sm-2 ps-md-4 ps-lg-4 ps-xl-4 ps-xxl-4 pe-2 pe-sm-2 pe-md-4 pe-lg-4 pe-xl-4 pe-xxl-4">
  <ul class="list-group mb-4">
    <!-- HEADER -->
    <li class="list-group-item dashboard subheader d-block p-0">
      <div class="row w-100 d-flex p-0 align-items-center item-row dashboard">
        <div
          class="col-md-2 col-lg-2 col-xl col-xxl d-none d-md-block ps-md-4 ps-lg-4 ps-xl-2 ps-xxl-2 text-truncate align-middle cursor-pointer"
          (click)="sortData('lastUpdate');">
          <input (click)="$event.stopPropagation();" type="checkbox"
            class="ms-3 mt-1 d-none d-xl-inline-block form-check-input checkbox dashboard" name="item" id="item"
            value="" (change)="$event ? masterToggle() : null;" [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()">
          <span class="cursor-pointer" translate="dashboard.activitylist.updated"></span>
          <div class="sorting sorting-item">
            <i class="bi bi-caret-up-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === 'lastUpdate' && this.descending }"></i>
            <i class="bi bi-caret-down-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === 'lastUpdate' && !this.descending }"></i>
          </div>
        </div>
        <div
          class="col-8 col-sm-8 col-md-4 col-lg-4 text-truncate cursor-pointer ps-4 ps-sm-4 ps-md-2 ps-lg-2 ps-xl-2 ps-xxl-2 "
          [ngClass]="{'col-xl-3 col-xxl-2': workgroup, 'col-xl-4 col-xxl-3': !workgroup }"
          (click)="sortData('requestName')"><span class="cursor-pointer" translate="dashboard.activitylist.request"></span>
          <div class="sorting sorting-item">
            <i class="bi bi-caret-up-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === 'requestName' && this.descending }"></i>
            <i class="bi bi-caret-down-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === 'requestName' && !this.descending }"></i>
          </div>
        </div>
        <div class="col-xl col-xxl d-none d-xl-block text-truncate cursor-pointer" (click)="sortData('_translatedType')">
          <span class="cursor-pointer" translate="dashboard.activitylist.type"></span>
          <div class="sorting sorting-item">
            <i class="bi bi-caret-up-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === '_translatedType' && this.descending }"></i>
            <i class="bi bi-caret-down-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === '_translatedType' && !this.descending }"></i>
          </div>
        </div>
        <div class="col-xl col-xxl d-none text-truncate cursor-pointer"
          [ngClass]="{'d-xl-block': !workgroup, 'd-xxl-block': workgroup }"
          (click)="sortData('_translatedPreviousAction')"><span class="cursor-pointer" translate="dashboard.activitylist.action"></span>
          <div class="sorting sorting-item">
            <i class="bi bi-caret-up-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === '_translatedPreviousAction' && this.descending }"></i>
            <i class="bi bi-caret-down-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === '_translatedPreviousAction' && !this.descending }"></i>
          </div>
        </div>
        <div class="col-xxl d-none d-xxl-block text-truncate cursor-pointer"
          (click)="sortData('previousActor')"><span class="cursor-pointer" translate="dashboard.activitylist.by"></span>
          <div class="sorting sorting-item">
            <i class="bi bi-caret-up-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === 'previousActor' && this.descending }"></i>
            <i class="bi bi-caret-down-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === 'previousActor' && !this.descending }"></i>
          </div>
        </div>
        <div class="col-md-2 col-lg-2 col-xl col-xxl d-none d-sm-none d-md-block text-truncate cursor-pointer"
          (click)="sortData('_translatedNextAction')"><span class="cursor-pointer" translate="dashboard.activitylist.stage"></span>
          <div class="sorting sorting-item">
            <i class="bi bi-caret-up-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === '_translatedNextAction' && this.descending }"></i>
            <i class="bi bi-caret-down-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === '_translatedNextAction' && !this.descending }"></i>
          </div>
        </div>
        <!-- <div
          class="col-md-2 col-lg-2 col-xl col-xxl d-none d-sm-none d-md-block d-lg-block d-xl-none d-xxl-block text-truncate cursor-pointer"
          (click)="sortData('nextActor')"><span class="cursor-pointer" translate="dashboard.activitylist.for"></span>
          <div class="sorting sorting-item">
            <i class="bi bi-caret-up-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === 'nextActor' && this.descending }"></i>
            <i class="bi bi-caret-down-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === 'nextActor' && !this.descending }"></i>
          </div>
        </div> -->
        <div class="col-4 col-sm-4 col-md-2 col-lg-2 col-xl col-xxl text-truncate cursor-pointer"
          (click)="sortData('deadline')"><span class="cursor-pointer" translate="dashboard.activitylist.deadline"></span>
          <div class="sorting sorting-item">
            <i class="bi bi-caret-up-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === 'deadline' && this.descending }"></i>
            <i class="bi bi-caret-down-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === 'deadline' && !this.descending }"></i>
          </div>
        </div>
        <div class="col-xl col-xxl d-none d-xl-block text-truncate cursor-pointer"
          *ngIf="workgroup && (userHasRequestsInWorkgroup() || showAll)" (click)="sortData('workgroupName')"><span class="cursor-pointer"
            translate="dashboard.activitylist.workgroup"></span>
          <div class="sorting sorting-item">
            <i class="bi bi-caret-up-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === 'workgroupName' && this.descending }"></i>
            <i class="bi bi-caret-down-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === 'workgroupName' && !this.descending }"></i>
          </div>
        </div>
        <div class="col-xl col-xxl d-none d-xl-block text-truncate cursor-pointer"
          *ngIf="workgroup && (userHasRequestsInWorkgroup() || showAll)" (click)="sortData('ownerName')"><span class="cursor-pointer"
            translate="dashboard.activitylist.owner"></span>
          <div class="sorting sorting-item">
            <i class="bi bi-caret-up-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === 'ownerName' && this.descending }"></i>
            <i class="bi bi-caret-down-fill" aria-hidden="true"
              [ngClass]="{'invisible': columnName === 'ownerName' && !this.descending }"></i>
          </div>
        </div>
      </div>
    </li>

    <!-- ALL REQUEST : MOBILE/TABLET (NO SPLICING OPTIONS) -->
    <li class="list-group-item dashboard d-block d-xl-none p-0"
      *ngFor="let request of requests | filter : filterMetadata | sortBy : orderBy : columnName "
      [ngClass]="{'active': selection.isSelected(request) }">
      <app-request-table-row [request]="request" [selection]="selection" [anyWorkgroup]="userHasRequestsInWorkgroup()"
        [workgroup]="workgroup"></app-request-table-row>
    </li>

    <!-- SPLICED REQUEST FOR DESKTOP -->
    <li class="list-group-item dashboard d-none d-xl-block p-0"
      *ngFor="let request of requests | filter : filterMetadata | sortBy : orderBy : columnName | slice: pageSize | slice: 0:itemsPerPage; let i = index;"
      [ngClass]="{'active': selection.isSelected(request) }">
      <app-request-table-row [request]="request" [selection]="selection" [anyWorkgroup]="userHasRequestsInWorkgroup()"
        [workgroup]="workgroup"></app-request-table-row>
    </li>

    <!-- display placeholders dashboard is loading -->
    <ng-container *ngIf="platformHubService.loading">
      <li class="list-group-item dashboard p-0"><app-request-table-is-loading-row></app-request-table-is-loading-row></li>
      <li class="list-group-item dashboard p-0"><app-request-table-is-loading-row></app-request-table-is-loading-row></li>
    </ng-container>

    <!-- display special no visible request when: NO request at all, or when all request are FILTERED out -->
    <ng-container
      *ngIf="!platformHubService.loading && requests != null && (requests.length == 0 || (requests | filter : filterMetadata).length == 0)">
      <app-no-requests [unfilteredRequestCount]="requests.length"
        [filteredRequestCount]="(requests | filter : filterMetadata).length">
      </app-no-requests>
    </ng-container>
  </ul>

  <div class="mt-2 mb-3 pb-3 w-100 d-none d-xl-block">
    <ng-container *ngIf="requests && requests.length > 0">
      <app-page-size-picker [(ngModel)]="itemsPerPage" (ngModelChange)="changePagesize($event)"
        [disabled]="((filterMetadata && filterMetadata.count > 0 && filterMetadata.count <= 10) || (requests | filter : filterMetadata).length <= 10)"
        [collectionSize]="filterMetadata.count > 0 ? filterMetadata.count : filterMetadata.count == 0 ? 1 : (requests | filter : filterMetadata).length"
        [currentPageNumber]="currentPage" (pageChangedTo)="onPageChanged($event)">
      </app-page-size-picker>
    </ng-container>
  </div>
</div>